// extracted by mini-css-extract-plugin
module.exports = {"App":"App__App___1o-Fp","App-logo":"App__App-logo___3JCPt","App-logo-spin":"App__App-logo-spin___RvI1J","App-header":"App__App-header___3iH8L","App-link":"App__App-link___13fTZ"};